const $ = window.jQuery

import appUtils from './app_utils'

import { throttle  } from 'lodash';

class HScroll {
  constructor(target, args = {}) {
    this.target = target

    this.$el = $(this.target)

    this.scrollMax = 0
    
    this.init()
  }

  init() {
    if (!this.$el.is('.hscroll-init')) {
      this.$el.addClass('hscroll-init')
      this.$el.data('hscroll-instance', this)

      let wrapperCssClass = ''
      if (this.$el.is('.wp-block-navigation__submenu-container')) {
        wrapperCssClass = 'wp-block-navigation__submenu-container'
        this.$el.removeClass('wp-block-navigation__submenu-container')
      }
      this.$el.wrap('<div class="data-hscroll-wrapper ' + wrapperCssClass + '"></div>')
      this.$wrapper = this.$el.parent('.data-hscroll-wrapper')
      this.$wrapper.prepend('<button aria-label="Scroll left" data-action="left" class="data-hscroll-btn-start btn icon-chevron-left"></button>')
      this.$wrapper.append('<button aria-label="Scroll right" data-action="right" class="data-hscroll-btn-end btn icon-chevron-right"></button>')
    
      this.scrollLeft = this.$wrapper.find('.data-hscroll-btn-start')[0]
      this.scrollRight = this.$wrapper.find('.data-hscroll-btn-end')[0]
  
      this.bindCallbacks()
  
      // https://stackoverflow.com/questions/10744645/detect-touchpad-vs-mouse-in-javascript/62415754#62415754
      this.target.addEventListener('wheel', this.onWheelBound, false)
      this.target.addEventListener('scroll', this.onScrollBound, false)
  
      this.scrollLeft.addEventListener('click', this.onBtnScrollClickBound, false)
      this.scrollRight.addEventListener('click', this.onBtnScrollClickBound, false)
  
      this.onResizeThrottle = throttle(this.onResizeBound, 400, {
        'leading': true,
        'trailing': true
      } )
  
      window.addEventListener('resize', this.onResizeThrottle, false)
      
      /*
      * MutationObserver to call onResize whenever markup changes
      * https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/observe 
      */
      this.observer = new MutationObserver(() => {
        this.onResizeBound()
      });
      this.observer.observe(this.target, {
        subtree: false,
        childList: true,
      })

      this.onResize()
    }
  }

  destroy() {
    this.observer.disconnect()

    this.target.removeEventListener('wheel', this.onWheelBound, false)
    this.target.removeEventListener('scroll', this.onScrollBound, false)

    this.scrollLeft.removeEventListener('click', this.onBtnScrollClickBound, false)
    this.scrollRight.removeEventListener('click', this.onBtnScrollClickBound, false)

    window.removeEventListener('resize', this.onResizeThrottle, false)

    this.$el.data('hscroll-instance', null)
  }

  bindCallbacks(){
    this.onResizeBound = this.onResize.bind(this)
    this.onWheelBound = this.onWheel.bind(this)
    this.onScrollBound = this.onScroll.bind(this)
    this.onBtnScrollClickBound = this.onBtnScrollClick.bind(this)
  }

  onBtnScrollClick(e) {
    if(e.target.dataset.action === 'left') {
      const scrollDestination = Math.max(0, this.target.scrollLeft - this.containerWidth)
      this.$el.animate({scrollLeft: scrollDestination}, 300);
    }
    if(e.target.dataset.action === 'right') {
      const scrollDestination = Math.min(this.scrollMax, this.target.scrollLeft + this.containerWidth)
      this.$el.animate({scrollLeft: scrollDestination}, 300);
    }
  }

  onWheel(e) {
    // const isTouchPad = e.wheelDeltaY ? e.wheelDeltaY === -3 * e.deltaY : e.deltaMode === 0 // not working on FF
    const isTouchPad = (Math.abs(e.wheelDeltaY) < 30)
    if (!isTouchPad) {
      e.preventDefault();
      const delta = e.deltaY < 0 ? -30 : 30
      this.target.scrollLeft -= delta;
    }
  }

  onScroll() {
    const scrollLeft = Math.ceil(this.target.scrollLeft)

    if (scrollLeft > 0) {
      this.$wrapper.addClass('data-hscroll-start')
    } else {
      this.$wrapper.removeClass('data-hscroll-start')
    }

    if (scrollLeft < this.scrollMax) {
      this.$wrapper.addClass('data-hscroll-end')
    } else {
      this.$wrapper.removeClass('data-hscroll-end')
    }
  }

  onResize() {
    // compare with this.target.offsetWidth if elements are not abs postitionet once hovered
    const containerWidth = (this.target.dataset.hscroll === 'window') ? (window.innerWidth - 48) : this.target.offsetWidth
    let contentWidth = 0 // this.target.scrollWidth: wrong value in case of justify-content: center;
    for (var i = 0; i < this.target.children.length; i++) {
      contentWidth += parseInt(this.target.children[i].offsetWidth, 10) + 2;
    }
    
    this.scrollMax = (contentWidth > containerWidth) ? (contentWidth - containerWidth) : 0
    this.containerWidth = containerWidth

    if (this.scrollMax > 0) {
       this.$el.addClass('data-hscroll-active')
    } else {
      this.$el.removeClass('data-hscroll-active')
    }

    this.onScroll()
  }
}

let hScrollInstances = []
/*
let onWindowResize = function(){
  if (hScrollInstances.length) {
    for(var i=0; i<hScrollInstances.length; i++){
      hScrollInstances[i].onResize()
    }
  }
}
const onWindowResizeThrottle = throttle(onWindowResize, 400, {
  'leading': true,
  'trailing': true
} )
*/

const appInit = function() {
  // appUtils.$window.on('resize', onWindowResizeThrottle)
}

const init = function() {
  $('[data-hscroll]').each(function() {
    let hscroll = new HScroll(this)
    hScrollInstances.push(hscroll)
  })
}

const destroy = function() {
  if (hScrollInstances.length) {
    for(var i=0; i<hScrollInstances.length; i++){
      hScrollInstances[i].destroy()
    }
    hScrollInstances = []
  }
}

export default {init, destroy, appInit, HScroll}
